class DocumentationUtils {

    static drawFilters(activeFilters, currentFolder) {
        let currentFilter = null;

        for (var i = 0; i < activeFilters.length; i++) {
            switch (activeFilters[i].filterType) {
                case 'completed':
                    currentFilter = $("#sort-completed-" + currentFolder.id);
                    break;

                case 'favourite':
                    currentFilter = $("#sort-favourite-" + currentFolder.id);
                    break;

                case 'new':
                    currentFilter = $("#sort-new-" + currentFolder.id);
                    break;

                case 'rating':
                    currentFilter = $("#sort-rating-" + currentFolder.id);
                    break;

                case 'test':
                    currentFilter = $("#sort-test-" + currentFolder.id);
                    break;

                case 'play':
                    currentFilter = $("#sort-play-" + currentFolder.id);
                    break;

                case 'share':
                    currentFilter = $("#sort-share-" + currentFolder.id);
                    break;
            }

            let status = activeFilters[i].status;
            currentFilter.attr("data-status", status);
            currentFilter.addClass('filterEnabled');
        }
    }

    static getAvailableFiltersAmount(world) {

        let availableFilters = 0;

        if (world.documentation_game_mode) {
            if (world.show_play_filter) {
                availableFilters += 1;
            }
            if (world.show_question_filter) {
                availableFilters += 1;
            }
        }

        if (world.shows_completion) {
            if (world.show_completed_filter) {
                availableFilters += 1;
            }
        }

        if (world.can_rate_documentation) {
            if (world.show_order_filter) {
                availableFilters += 1;
            }
        }

        if (world.show_favourite_filter) {
            availableFilters += 1;
        }

        if (world.show_new_filter) {
            availableFilters += 1;
        }

        if (world.show_link_filter) {
            availableFilters += 1;
        }

        return availableFilters;

    }

    static initDetailCanvas(folderId, document, isComment) {
        $('.quiz-wrapper').addClass('document-details-wrapper');

        let favouriteIcon = customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_FAVORITE"];
        let shareIcon = customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_SHARE"];
        let comentIcon = customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_COMMENT"];
        let rateIcon = customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_RATE"];
        let playIcon = customIcons["DOCUMENTATION_BOTTOM_NAVIGATION_PLAY"];

        let canvasList = ['documentSetFavourite'];
        let canvasFiles = [favouriteIcon];

        if (world.can_comment_documentation) {
            if (isComment) {
                canvasList.push("sendCommentIcon");
                canvasFiles.push("/images/ico_action_send-40.png");
            } else {
                canvasList = canvasList.concat(["documentComment", "sendCommentIcon"]);
                canvasFiles = canvasFiles.concat([comentIcon, "/images/ico_action_send-40.png"]);
            }
        }

        if (!document.has_test && document.has_questions) {
            canvasList = canvasList.concat(["documentPlay"]);
            canvasFiles = canvasFiles.concat([playIcon]);
        }

        if (world.can_rate_documentation) {
            canvasList.push("documentRate");
            canvasFiles.push(rateIcon);
        }

        if (world.can_share_documents && document.enabledLinks) {
            canvasList.push("documentShare");
            canvasFiles.push(shareIcon);
        }

        for (let index in canvasList) {
            let canvasItem = $('#' + canvasList[index] + '-' + document.id + '-details');
            tintImage(canvasItem.attr('id'), canvasFiles[index], rgb2hex(canvasItem.css('color')));
        }
    }

    static formatCompletedTime(duration){

        const second = 1000;
        const minute = 60 * second;
        const hour = 60 * minute;

        if (duration < minute) {
            return Math.round(duration / second) + " s";
        }

        if (duration < hour) {
            return Math.round(duration / minute) + " min";
        }

        if (duration >= hour) {
            // Redondeo mas cercano a .5 decimal
            return formatValueByLocale(Math.round((duration / hour) / 0.5) * 0.5) + " h";
        }

    }

    static getSelectedRating(document) {
        switch (true) {
            case (document.rating_average > 4):
                return 5;
                break;
            case (document.rating_average <= 4 && document.rating_average > 3):
                return 4;
                break;
            case (document.rating_average <= 3 && document.rating_average > 2):
                return 3;
                break;
            case (document.rating_average <= 2 && document.rating_average > 1):
                return 2;
                break;
            case (document.rating_average <= 1):
                return 1;
                break;
        }
    }

    static formatDocumentCompletedUsers(document, data) {

        const lastUsers = data.result.users ? data.result.users.length : 0;
        const totalUsers = parseInt(data.result.total);
        const otherUsers = totalUsers - lastUsers;
        const multiplier = otherUsers / 25; // El contador de usuarios extra se mostrara siempre de 25 en 25 unidades
        const showOtherUsersCounter = parseInt(multiplier) > 0;

        document.completedDocumentUsers = data.result;
        document.completedDocumentUsers.showOtherUsersCounter = showOtherUsersCounter;
        document.completedDocumentUsers.otherUsersCounter = parseInt(multiplier) * 25;

    }

    static formatKMnumber(kmNumber) {
        return kmNumber > 1000000 ? (kmNumber / 1000000).toLocaleString('es-ES') + "M" : kmNumber > 1000 ?
            (kmNumber / 1000).toLocaleString('es-ES') + "K" : kmNumber.toLocaleString('es-ES');
    }

    static resizeNoItemsPlaceholder() {
        let windowHeight = $(window).height();
        let restOfHeight = $('header').outerHeight() + $('#documentationDetailSection').find('.wrapper').outerHeight() + 80; // 80px borde inferior

        $(".not-info").css('min-height', windowHeight - restOfHeight);
    }

    static formatDocParameters(folder) {
        for (var i = 0; i < folder.documents.length; i++) {
            DocumentationUtils.formatDocumentParameters(folder.documents[i], folder);
        }
    }

    // Convert formatDocumentParameters in a pure function (Used in new react code 2024)
    static pureFormatDocumentParameters(documentId, folder) {
        let doc = documentationScreenController.getDocument(documentId);

        DocumentationUtils.formatDocumentParameters(doc, folder);

        return doc;
    }

    static formatDocumentParameters(document, folder) {
        if(!document) {
            return;
        }

        const totalComments = document?.total_comments ?? 0;

        if (totalComments) {
            document.total_comments_formatted = DocumentationUtils.formatKMnumber(document.total_comments);
        } else {
            document.total_comments_formatted = 0;
        }

        if (document?.media_duration)
            document.media_duration_formatted = DocumentationUtils.formatCompletedTime(document.media_duration);
        else if (document?.time_completable_total) {
            document.completed_time_formatted = DocumentationUtils.formatCompletedTime(document.time_completable_total);
        }

        if (document.type === "URL") {

            if (document.content_external && document.content_external.rel.indexOf("playerjs") >= 0 && document.content_external.duration) {
                document.completed_time_formatted = DocumentationUtils.formatCompletedTime(document.content_external.duration);
            } else if (document.time_completable_total) {
                document.completed_time_formatted = DocumentationUtils.formatCompletedTime(document.time_completable_total);
            }

            if (document.content_external && document.content_external.site.logo) {
                document.icon_type = document.content_external.site.logo;
            }
        }

        if (document.game) {
            document.rounded_qualification = Math.round(document.game.qualification * 10) / 10;
        }

        if (document.completed_points)
            document.completed_points_formatted = DocumentationUtils.formatKMnumber(document.completed_points);

        if (document.rating_average)
            document.rating_selected = DocumentationUtils.getSelectedRating(document);

        if (document.created_at) {
            document.created_at_formmated = formatToDateSystem(document.created_at);
        }

        let showTestButton = true;

        if (world.shows_completion && !document.completed) {
            showTestButton = false;
        }

        document.show_test_button = showTestButton;

        if (document.game)
            document.rounded_qualification = Math.round(document.game.qualification * 10) / 10;

        if (!document.parentFolder && folder) {
            document.parentFolder = {
                'name': folder.name,
                'color': folder.color,
                'colorCode': folder.color.replace('#', '')
            };
        }

        if (!document.icon) {
            document.icon = "images/uploadDocDefThumb.jpg";
        }

    }

    static formatCommentsDate(commentList) {
        for (var i = 0; i < commentList.length; i++) {
            var commentItem = commentList[i];

            if (typeof (commentItem.date) == 'number') {
                commentItem.formatDate = formatToDateSystem(commentItem.date);
            }
        }

        return commentList;
    }

    static drawTestPieChart(cont) {
        let correctAnsw = cont.data('correct');
        let totalAnsw = cont.data('total');
        let wrongAnsw = totalAnsw - correctAnsw;
        let pieSize = 28;
        let chartSize = 35;

        if ($(window).width() <= 420) {
            pieSize = 24;
            chartSize = 30;
        }

        if (!totalAnsw || totalAnsw === 0) {
            correctAnsw = 0;
            wrongAnsw = 1;
        }

        if (wrongAnsw === 0)
            wrongAnsw = null;

        cont.highcharts({
            chart: {
                type: 'pie',
                width: chartSize,
                height: chartSize,
                backgroundColor: 'rgba(0, 0, 0, 0)',
                spacing: [15, 15, 15, 15]
            },
            colors: ['#6BC23B', '#F5222D'],
            title: {text: null},
            credits: {enabled: false},
            tooltip: {enabled: false},
            plotOptions: {
                pie: {allowPointSelect: false, dataLabels: {enabled: false}, size: pieSize, borderColor: null},
                series: {states: {hover: {enabled: false}}, animation: false}
            },
            series: [{colorByPoint: true, data: [['Right', correctAnsw], ['Wrong', wrongAnsw]]}]
        });
    }

    static drawTooltip(selector) {
        selector.tooltip({classes: {"ui-tooltip": "basic-tooltip"}});
        // Si se accede desde movil el tooltip debe aparecer al clickarse sobre el y desaparecer al hacer scroll.
        if (detectmob()) {
            selector.off().on('click', function () {
                selector.tooltip('open');
                $(window).off('touchmove.closeTooltip').on('touchmove.closeTooltip', function (e) {
                    selector.tooltip('close');
                    $(window).off('touchmove.closeTooltip');
                });
                return false;
            });
        }
    }

    static getFolderTreeDropdown(userFolderId, availableFolders) {

        const formFolder = $("select.form-folder");
        let folderTab = "";

        _.forEach(availableFolders, function (availableFolder) {
            formFolder.append('<option value="' + availableFolder.id + '">' + folderTab + availableFolder.name + '</option>');
            if (userFolderId == availableFolder.id) {
                formFolder.val(availableFolder.id);
            }
        });
    }

    static selectFirstFolder(folderId) {

        const currentFolder = $('select.form-folder option[value="' + folderId + '"]');
        let firstEnabledOption = null;

        $('select.form-folder option').each(function () {
            if ($(this).is(':enabled')) {
                firstEnabledOption = $(this);
                return false;
            }
        });

        $('select.form-folder option:selected').removeAttr('selected');
        currentFolder ? currentFolder.prop('selected', true) : firstEnabledOption.prop('selected', true);

        this.folderId = $("select.form-folder").val();

    }

    static getAvailableTimes(day) {

        const date = new Date();
        const currentDay = date.getDate();
        const currentHour = date.getHours();
        const currentMinute = date.getMinutes();
        const timesArray = [];
        let hour = 0;
        let minute = 0;

        if (currentDay === day) {
            if (currentMinute >= 0 && currentMinute < 30) {
                timesArray.push(currentHour + ":" + "30");
            }

            hour = currentHour + 1;

        }

        for (hour; hour < 24; hour += 1) {
            for (minute = 0; minute < 2; minute += 1) {
                timesArray.push(hour + ":" + (minute === 0 ? "00" : 30 * minute));
            }
        }

        return timesArray;

    }

    static showPointsModal(points, documentId) {
        try {
            $("#modalContainer").addClass("darkerModalBackground");
            $("#modalContainer").css('position', 'fixed');
            let template = Handlebars.compile($("#documentPointsModal").html());
            let currentScroll = window.scrollY; //$('body').getNiceScroll()[0].getScrollTop();

            const closeModal = function() {
                $("#document-points-area").hide();
                $("#document-points-amount").empty();
                $("#modalContainer").modal('hide').empty();
            };

            $(document).one("shown.bs.modal", '#modalContainer', function () {
                $("#document-points-amount").text(points.toLocaleString("es-ES"));
                $("#document-points-area .text-area").show();

                $("#document-points-area .btn-close").click(function () {
                    closeModal();
                });

                try {
                    window.scrollTo(0, currentScroll);

                    let pointsAnimation = $("#gif-document-points");
                    var rub = new SuperGif({
                        gif: pointsAnimation[0],
                        auto_play: false,
                        draw_while_loading: false,
                        loop_mode: false,
                        on_end: () => {
                            setTimeout(function () {
                                closeModal();
                            }, 300);
                        }
                    });

                    let pointsGifUrl = "/images/points_animation.gif";

                    if (world.theme.document_animation_points != null) {
                        pointsGifUrl = world.theme.document_animation_points;
                    }

                    let audioElement = document.createElement('audio');
                    let pointsSound = '/images/points_sound.wav';

                    if (world.theme.document_sound_points) {
                        pointsSound = world.theme.document_sound_points;
                    }

                    audioElement.setAttribute('src', pointsSound);

                    rub.load_url(pointsGifUrl, function () {
                        rub.play();
                        audioElement.play();
                    });
                } catch (e) {
                    console.error(e);

                    setTimeout(function () {
                        closeModal();
                    }, 3500);
                }
            });

            $("#modalContainer").html(template()).modal('show');

            let hasNotCompletedFilter = $(".filterEnabled[data-filter='completed'][data-status='2']").length;

            if (hasNotCompletedFilter) {
                let documentationContent = $("body").last();
                documentationContent.find("a[data-id='" + data['document_id'] + "']").closest("li").remove();

                let documentsLength = documentationContent.find("#documentation-documents li").length;
                $("#folder-items-amount-" + folderId).text(" (" + documentsLength + ")");

                let currentScroll = null; //documentationContent.getNiceScroll()[0];
                let lastScroll = documentationContent.data("scroll");

                documentationScreenController.documentationScroll.manageItemsScroll(null, currentScroll, lastScroll);
            }

            if (documentId) {
                let testBar = $(".preview-separator[data-document='" + documentId + "']");

                testBar.find('.startTestBtn').removeClass('disabled-test-btn');
                testBar.find('.disabled-test-btn-text').hide();
                testBar.find('.enabled-test-btn-text').show();
                let detailTestBar = $('#startTestBtn');
                detailTestBar.removeClass('disabled-test-btn');
                detailTestBar.find('.disabled-test-btn-text').hide();
                detailTestBar.find('.enabled-test-btn-text').show();
            }

        } catch (e) {
            console.trace('Error on showPointsModal: ', {points, documentId});

            if (window.Sentry) {
                Sentry.captureException(e);
            }
        }
    }

    static likeAnimation(selector, onEndFunction) {

        const likeAnimation = selector;
        const animation = bodymovin.loadAnimation({
            container: likeAnimation[0],
            path: '/images/lottie-like-anim01.json',
            renderer: 'svg',
            loop: false,
            autoplay: true,
            name: "like Animation",
        });

        animation.addEventListener('complete', function () {
            onEndFunction();
        })

    }

    static calculateSearchInputWidth(classPrefix) {

        const that = this;
        // Necesario para evitar desbordamientos, por seguridad se deja un poco de anchura extra.
        const documentationFilters = documentationScreenController.documentationFilters;
        const extraSpace = 5;
        const containerWidth = $('.' + classPrefix + '-filters-container').last().outerWidth();
        const closeButtonWidth = $('.' + classPrefix + '-filters-button-close-container').last().outerWidth();
        const filtersWidth = $('.' + classPrefix + '-filters').last().outerWidth();
        const searchInput = $('.' + classPrefix + '-searcher').last();
        const filters = $('.' + classPrefix + '-filters').last();
        const closeButton = $('.' + classPrefix + '-filters-button-close-container').last();
        // Este es el espacio que queda libre para colocar el buscador en la misma linea que los filtros
        const freeSearchInputWidth = containerWidth - closeButtonWidth - filtersWidth - extraSpace;
        // Este es el espacio que queda para crecer la fila de filtros en caso de que se haya puesto el buscador abajo ocupando el 100% y los filtros arriba
        const freeFiltersWidth = containerWidth - closeButtonWidth - filtersWidth - extraSpace;

        // Mientras el buscador no tenga menos anchura de la que se define por defecto, colocar el buscador con toda la anchura disponible en la misma fila que los filtros
        if (freeSearchInputWidth >= $('.wrapper').last().width() * documentationFilters.defaultInputSearchMinWidth) {
            searchInput.width(freeSearchInputWidth);
            // Cuando el espacio que queda libre no es suficiente, el buscador se coloca abajo con un 100% y los filtros arriba
        } else {
            searchInput.addClass('two-row-filters');
            filters.addClass('two-row-filters');
            closeButton.addClass('two-row-filters');
            searchInput.css('width', '100%');
            filters.css('width', filters.outerWidth() + freeFiltersWidth + 'px')
        }

        return freeSearchInputWidth;

    }

    static applyDocumentationFilters(selectedFilter, filtersContainer, documentsToFilter) {

        if (selectedFilter.hasClass("filterEnabled")) {
            selectedFilter.removeClass("filterEnabled");
        } else {
            selectedFilter.addClass("filterEnabled");
        }

        const activeFilters = filtersContainer.find(".filterEnabled");
        let filteredDocuments = documentsToFilter;

        _.forEach(activeFilters, function (activeFilter) {

            const filterType = $(activeFilter).data("filter");

            switch (filterType) {
                case "completed":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.completed
                    });
                    break;

                case "favourite":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.favourite
                    });
                    break;

                case "new":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.new == null || doc.new
                    });
                    break;

                case "test":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.has_test && doc.has_questions
                    });
                    break;

                case "play":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.has_test && doc.has_questions
                    });
                    break;

                case "rating":
                    filteredDocuments = _.sortBy(filteredDocuments, [function (filteredDocument) {
                        return -filteredDocument.rating_average;
                    }])
                    break;

                case "share":
                    filteredDocuments = filteredDocuments.filter(function (doc) {
                        return doc.is_shared
                    });
                    break;
            }

        });

        return filteredDocuments;

    }

    // FIX El visor de google gview a veces no carga los documentos
    static insertDocIframe($iframe, src, retry) {

        $iframe.attr("src", "https://docs.google.com/gview?embedded=true&url=" + src);

        try {
            $iframe.contents().find("body");
        } catch (error) {
            retry = false;
        } finally {
            if (retry) {
                setTimeout(function () {
                    DocumentationUtils.insertDocIframe($iframe, src, retry);
                }, 500);

            }
        }

    }

    static isWebsite(document) {

        let isWebsite = false;

        if (document.type === "URL") {

            if (!document.content_external) {

                isWebsite = true;

            } else {

                const hasHtml = document.content_external.html !== null;
                const hasSummary = document.content_external.rel.indexOf("summary") >= 0;

                isWebsite = !hasHtml || hasSummary;

            }

        }

        return isWebsite;

    }

    static calcDetailsViewHeight() {

        const totalHeight = $(window).height();
        const docOptionsBarHeight = $(".bottomOptionsBar").last().height();
        const extraSpace = 5; // Los bordes del docOptionsBar estan redondeados, el wrapper ocupara "extraSpace" mas para que no se vea el color de fondo.

        if (docOptionsBarHeight) {
            $("#documentationDetailSection .wrapper").css("height", totalHeight + extraSpace - docOptionsBarHeight + "px");
        } else {
            $("#documentationDetailSection .wrapper").css("height", totalHeight + "px");
        }


    }

    static formatCommentMentions(comment, mentions, authorWorldId) {

        let formatComment = comment;

        if (mentions && mentions.length > 0) {

            _.forEach(mentions, function (mention) {
                // El authorWorldId se utiliza para poder dar un color más clarito a la mencion ya que si es el propio autor sale el fondo del comentario del mismo color que las menciones
                if (user.user_world_id === authorWorldId) {
                    formatComment = formatComment.replaceAll("@{" + mention.id + "}", "<span class='is-author-current-user open-profile-button' data-user='" + mention.id + "'>" + mention.label + "</span>");
                } else {
                    formatComment = formatComment.replaceAll("@{" + mention.id + "}", "<span class='world_color_1 open-profile-button' data-user='" + mention.id + "'>" + mention.label + "</span>");
                }
            });

            return formatComment;

        }

        return comment;

    }

    static formatNotificationCommentMentions(comment, mentions, authorWorldId) {

        let formatComment = comment;

        if (mentions && mentions.length > 0) {
            _.forEach(mentions, function (mention) {
                // El authorWorldId se utiliza para poder dar un color más clarito a la mencion ya que si es el propio autor sale el fondo del comentario del mismo color que las menciones
                if (user.user_world_id === authorWorldId) {
                    formatComment = formatComment.replaceAll("@{" + mention.id + "}", "<span data-user='" + mention.id + "'>@" + mention.label + "</span>");
                } else {
                    formatComment = formatComment.replaceAll("@{" + mention.id + "}", "<span data-user='" + mention.id + "'>@" + mention.label + "</span>");
                }
            });

            return formatComment;
        }

        return comment;
    }

    static isPlayableDocument(documentType) {
        return ['VIDEO', 'AUDIO'].indexOf(documentType) >= 0;
    }

    static isMultimediaDocument(documentType) {
        return ['VIDEO', 'AUDIO', 'GALLERY'].indexOf(documentType) >= 0;
    }

    static isSpecialDocument(documentType) {
        return ['GAME', 'TEST', 'POLL', 'TASK'].indexOf(documentType) >= 0;
    }

    static isAutomaticReadingDocument(documentType) {
        return ['VIDEO', 'AUDIO', 'GALLERY', 'IMAGE'].indexOf(documentType) >= 0;
    }

    static isAdvancedDocument(documentType) {
        return ['HEADLINE', 'BANNER', 'BANNERX2', 'DECO_GALLERY'].indexOf(documentType) >= 0;
    }

}